import React, { useEffect, useState } from 'react';
import axios from 'axios';

function GroupList() {
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        axios.get('/groups/api/list/')
            .then(response => setGroups(response.data))
            .catch(error => console.error('Error fetching groups:', error));
    }, []);

    return (
        <div>
            <h1>Group List</h1>
            <ul>
                {groups.map(group => (
                    <li key={group.id}>{group.name} - Grade: {group.grade_level}</li>
                ))}
            </ul>
        </div>
    );
}

export default GroupList;
